<template>
    <div :class="['about', { 'is-mobile': isMobile }]">
        <section class="section-1" ref="sec1" :style="{ height: isMobile && height }">
            <div class="content">
                <picture>
                    <source media="(max-width: 1440px)" :srcset="text.first.title[1]" sizes="" />
                    <source media="(max-width: 600px)" :srcset="text.first.title[2]" sizes="" />
                    <!-- <img class="title textfade textfade1" :src="text.first.title[0]" alt="" /> -->
                    <h2 v-if="isMobile" class="title textfade textfade1">
                        国内领先的低空基础设施<br />解决方案服务商
                    </h2>
                    <h2 v-else class="title textfade textfade1">国内领先的低空基础设施解决方案服务商</h2>
                </picture>
            </div>
        </section>
        <section class="section-2" ref="sec2">
            <h4 :class="['title']">
                关于我们
            </h4>
            <p :class="['text']" style="margin-bottom: 30px;">
                埃洛克航空是中国领先的低空基础设施解决方案提供商，2015年由航天、中科院及互联网领域顶尖团队创立，具备国家级军转民技术背景。公司深度参与多项无人机领域“国家重点研发计划”，拥有近百项核心专利，并作为民航局低空地理信息与航路重点实验室建设单位，奠定行业基石。依托自主可控的无人机控制系统、空间AI决策系统、及高性能引擎平台，埃洛克航空为智慧城市、应急管理、生态保护、文旅创新等领域提供空间智能解决方案，致力于构建低空服务网络基础设施。
            </p>
            <p>
                中文名：埃洛克航空
            </p>
            <p>
                所属公司：埃洛克航空科技（北京）有限公司
            </p>
            <p>
                荣誉：国家级高新技术企业、北京市“专精特新”中小企业
            </p>
        </section>
        <section class="section-3" ref="sec3">
            <h4 :class="[
                'title ',
            ]">
                企业定位
            </h4>
            <p :class="[
                'text',
            ]">
                国内领先的低空基础设施解决方案服务商，专注于低空产业数字化技术研发与场景化应用，覆盖无人机全产业链技术闭环，推动低空经济生态建设。
            </p>
            <h4 :class="[
                'title',
            ]">
                企业使命
            </h4>
            <p :class="[
                'text',
            ]">
                让每一次飞行都创造价值
            </p>
            <p :class="[
                'text',
            ]">
                我们致力于通过自主无人机技术突破能力与空间边界，为应急救援、生态保护、智慧城市等领域提供三维空间智能解决方案，让科技翅膀承载人类进步的希望。
            </p>
            <h4 :class="[
                'title',
            ]">
                企业愿景
            </h4>
            <p :class="[
                'text',
            ]">
                成为空间智能革命的引领者
            </p>
            <p :class="[
                'text',
            ]">
                2030年前建成覆盖低空领域的无人系统交通网络（UTM），让安全、高效、环保的无人机服务成为现代社会的基础设施。
            </p>
        </section>

        <section class="section-4" ref="sec4">
            <h4 :class="['title']">核心业务</h4>
            <h5>1. 低空产业服务</h5>
            <p :class="['text']">
                “低空服务”是低空产业的基础设施，是城市低空运行的大脑。有了低空服务，飞机才能安全飞、随时飞。业务涵盖：空域申请、航线审批、eVTOL适航、低空公共服务及托管运行、产业应用示范等。
            </p>
            <h5>2. 行业解决方案</h5>
            <p :class="['text']">
                依托无人机核心研发能力、高性能引擎及AI决策系统，埃洛克航空为各行业提供智能化低空解决方案：
            </p>
            <p :class="['text']">
                低空+文旅：空间复刻技术结合引擎应用，打造数字文化内容，覆盖40+城市，服务70万+用户。
            </p>
            <p :class="['text']">
                低空+测绘：高效获取实景三维数据，支持厘米级定位，满足高精度测绘需求。
            </p>
            <p :class="['text']">
                低空+巡检：AI图像识别实现光伏故障自动检测与报告生成。
            </p>
            <p :class="['text']">
                低空+消防：无人机自动巡航，实时监测火情，提升应急响应能力。
            </p>
            <h5>3. 未来立体交通</h5>
            <p :class="['text']">
                公司正推动大型电动垂直起降（eVTOL）货运机及载人机的研发，布局未来产业的城市交通网络构建，重塑空间出行新方式。
            </p>
        </section>

        <!-- <section class="section-5" ref="sec5">
            <h4 :class="['title']">发展大事件</h4>
            <p :class="['text']">
                2016年11月，向时任中宣部部长刘云山汇报飞机研发成果及应用；
            </p>
            <p :class="['text']">
                2017年7月，向中国民航局汇报”民用无人驾驶航空器综合管理平台”;
            </p>
            <p :class="['text']">
                2020年7月，向时任国家防总秘书长、应急管理部副部长兼水利部副部长周学文汇报无人机应急及防汛应用成果；
            </p>
            <p :class="['text']">
                2021年10月，向中国科技部原部长徐冠华汇报低空航图应用成果；
            </p>
            <p :class="['text']">2025年3月，向中宣部副部长曹淑敏汇报低空+文旅成果;</p>
            <p :class="['text']">2025年5月，向文旅部副部长饶权汇报低空+文旅成果；</p>
        </section> -->

        <section class="section-5" ref="sec5">
            <h4 :class="['title']">重要贡献</h4>
            <p :class="['text']">中国民用航空局低空地理信息与航路重点实验室建设单位；</p>
            <p :class="['text']">民用无人驾驶航空器综合管理平台（UOM）首版建设单位；</p>
            <p :class="['text']">国家重点研发计划“高频次迅捷无人航空器组网遥感观测技术”项目编号:2017YFB0503005；</p>
            <p :class="['text']">国家重点研发计划“面向无人机机群协同作业的区域救援目标识别及生命定位技术装备”项目编号：2021YFC3002100；</p>
            <p :class="['text']">国家重点研发计划“城镇可持续发展关键技术与装备” 项目编号：2022YFC3800702；</p>
            <p :class="['text']">中国科学院A类战略性先导科技专项“地球大数据科学工程（CASEarth）”城市三维地图提供方；</p>
            <p :class="['text']">中国《实景三维中国建设大纲（2021版）》技术编写单位；</p>
            <p :class="['text']">中国实景三维地图加密算法牵头研发单位；</p>
        </section>

        <!-- <section class="section-6" ref="sec6">
            <h3 :class="['title textfade', isMobile ? show2&&'textfade1':'textfade2']">{{ text.second.title }}</h3>
            <p :class="['text textfade', isMobile ? show2&&'textfade2':'textfade3']" v-html="text.second.text"></p>
        </section> -->
        <section class="section-7" id="contact" ref="sec7">
            <!-- <h3>
                {{ text.third.title }}
            </h3>
            <div class="wrap">
                <div class="con">
                    <div v-for="(item, index) in text.third.contact" :key="item.id" :id="item.id">
                        <h4 class="title">{{ item.title }}</h4>
                        <span>{{ item.tel }}</span>
                        <span>{{ item.email }}</span>
                        <span>{{ item.email_tech }}</span>
                        <span>{{ item.address }}</span>
                    </div>
                </div>
            </div> -->
        </section>
        <foot @contact="handleToContact"></foot>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { isMobile } from "@/js/utils";
import { about } from "@/js/text.js";
export default {
    name: "about",
    metaInfo: {
        meta: [
            {
                name: "keywords",
                content:
                    "AIoT物理空间应用平台, 守望者,无人机,自动机场,侦查系统,自动巡检,AI,深度学习,图像识别,目标跟踪",
            },
            {
                name: "description",
                content:
                    "埃洛克防务系统（南京）有限公司为元宇宙地图服务商AIRLOOK的全资子公司，核心定位于打造“城市级AIoT物理空间应用平台”。公司依托强大的空间组网体系与成图技术对现实物理空间数字化仿真，同时结合多元化物联网数据的接入，创建了一个可实时感知、可洞悉趋势的城市数字孪生系统，驱动智能化的空间管控理念在政府管理以及各类行业级场景中渗透和应用。",
            },
        ],
    },
    data() {
        return {
            isMobile: false,
            height: "100vh",
            show3: false,
            show2: false,
        };
    },
    components: {
        Foot: () => import("@/components/footer.vue"),
    },
    computed: {
        ...mapState(["headerStyle"]),
        text() {
            return this.$route.params.lang === "EN" ? about.EN : about.CN;
        },
    },
    methods: {
        ...mapMutations(["setHeaderStyle"]),
        handleToContact() {
            this.setHeaderStyle({ headerStyle: "dark" });
            document.body.scrollTop =
                this.$refs.sec1.offsetHeight + this.$refs.sec2.offsetHeight;
            document.documentElement.scrollTop =
                this.$refs.sec1.offsetHeight + this.$refs.sec2.offsetHeight;
        },
        resize() {
            this.isMobile = window.innerWidth <= 600 || isMobile();
        },
        initEvent() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            let h1 = this.$refs.sec1.offsetHeight;
            let h2 = this.$refs.sec2.offsetHeight;
            let h3 = this.$refs.sec3.offsetHeight;
            let h4 = this.$refs.sec4.offsetHeight;
            let h5 = this.$refs.sec5.offsetHeight;
            let h6 = this.$refs.sec6.offsetHeight;
            let h7 = this.$refs.sec7.offsetHeight;
            if (scrollTop >= h1 - 40 && scrollTop < h1 + h2 + h3 - 40) {
                this.setHeaderStyle({ headerStyle: "dark" });
            }
            if (scrollTop <= h1 - 40 || scrollTop > h1 + h2 + h3 - 40) {
                this.setHeaderStyle({ headerStyle: "light" });
            }
            // if (scrollTop > h1 * 0.3 && !this.show2) {
            //     this.show2 = true;
            // }
            // if (
            //     (scrollTop > h1 + h2 * 0.3 && !this.show3 && this.isMobile) ||
            //     (scrollTop > h1 && !this.show3 && !this.isMobile)
            // ) {
            //     this.show3 = true;
            // }
            if (
                (scrollTop > h1 + h2 + h3 + h4 + h5 + h6 * 0.2 && !this.show3 && this.isMobile) ||
                (scrollTop > h1 + h2 + h3 + h4 + h5 && !this.show3 && !this.isMobile)
            ) {
                this.show3 = true;
            }
        },
    },
    created() {
        this.isMobile = window.innerWidth <= 600 || isMobile();
    },
    mounted() {
        this.isMobile = window.innerWidth <= 600 || isMobile();
        this.$nextTick(() => {
            if (this.isMobile) {
                this.height = this.$refs.sec1.offsetHeight + "px";
            }
        });
        if (this.$route.hash === "#contact") {
            this.setHeaderStyle({ headerStyle: "dark" });
            setTimeout(
                () => {
                    let h = this.$refs.sec1.offsetHeight + this.$refs.sec2.offsetHeight;
                    document.body.scrollTop = h;
                    document.documentElement.scrollTop = h;
                },
                this.isMobile ? 50 : 0
            );
        }
        this.setHeaderStyle({ headerStyle: "light" });
        window.addEventListener("resize", this.resize);
        window.addEventListener("scroll", this.initEvent);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resize);
        window.removeEventListener("scroll", this.initEvent);
    },
};
</script>
<style lang="scss">
@import "../assets/css/about.scss";
</style>